import Cookie from '@/utils/Cookie';
import { http } from '@/plugins/http';

const RECAPTCHA_SITE_KEY = Cookie.get('recaptcha_site_key');

export const reCaptcha = new Promise((resolve, reject) => {
  const $script = document.createElement('script');
  $script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
  resolve(document.head.appendChild($script));
  setTimeout(() => reject(new Error('Google reCaptcha не инициализирована')), 3000);
});

export function reCaptchaToken() {
  return new Promise(resolve => {
    reCaptcha.then(() => {
      if (RECAPTCHA_SITE_KEY) {
        setTimeout(() => {
          grecaptcha.ready(() => {
            grecaptcha
              .execute(RECAPTCHA_SITE_KEY, { action: 'homepage' })
              .then(token => {
                resolve(token);
              })
              .catch(rej => {
                console.log(rej);
                resolve(false);
              });
          });
        }, 1000);
      } else {
        resolve(false);
      }
    });
  });
}